import { Box, CircularProgress } from "@material-ui/core";
import React from "react";
import Text from "../../../../../../shared/components/Text";

export const FullScreenLoading = ({ textId = "LOADING" }) => {
  return (
    <>
      <Box />
      <Box
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        width={"100%"}
        height={"100%"}
        gridGap={16}
      >
        <CircularProgress size={20} />
        <Text tId={textId} />
      </Box>
      <Box />
    </>
  );
};
